const groupPrefix = createApiRoute(ApiModule.CLIENT, ApiAuthorization.EMPLOYEE, ApiDataModel.TEAMS)

export const apiClientTeams = {
	fetchClientTeams: async (client_uuid: string): Promise<IClientTeamModel[]> => {
		const { data } = await apiCommon<IClientTeam[]>(`${groupPrefix}`, {
			method: 'GET',
			...createQuery(null, { client_uuid }),
		})

		return data.map(d => ClientTeam(d))
	},

	fetchSingleClientTeam: async (id: number): Promise<IClientTeamModel> => {
		const { data } = await apiCommon<IClientTeam>(`${groupPrefix}/${id}`, { method: 'GET' })

		return ClientTeam(data)
	},

	toggleClientInvitations: async (clientUUID: string) => {
		await apiCommon(`${groupPrefix}/toggle-invitations`, {
			method: 'PATCH',
			body: { client_uuid: clientUUID },
		})
	},

	toggleTeamOwnership: async (client_uuid: string, new_owner_client_uuid: string) => {
		await apiCommon(`${groupPrefix}/transfer-ownership`, {
			method: 'PATCH',
			body: {
				client_uuid,
				new_owner_client_uuid,
			},
		})
	},

	setNewClientLabel: async (client_uuid: string, receiver_client_uuid: string, label: string) => {
		await apiCommon(`${groupPrefix}/members/label`, {
			method: 'PATCH',
			body: {
				client_uuid,
				receiver_client_uuid,
				label,
			},
		})
	},
}
